<template>
    <div>
        <div id="side-page" class="side-page" :class="{ active: isActive }">
            <div id="side-page-wrapper">
                <div id="side-page-controls-container">
                    <div id="side-page-controls" class="side-page-controls">
                        <div 
                            style="position:relative;width:20px;height: 20px;"
                            @click="skrytSidePage()"
                            class="side-page-close-btn"
                        >
                            <span class="ox-toggler__bar" style="position:absolute; transform: rotate(-45deg);top:50%;left:0;"></span>
                            <span class="ox-toggler__bar" style="position:absolute; transform: rotate(45deg);top:50%;left:0;"></span>
                        </div>
                    </div>
                </div>
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isActive: false
            }
        },
        methods: {
            zobrazitSidePage(){
                this.isActive = true;
            },
            skrytSidePage(){
                this.isActive = false;
            }
        },
    }
</script>

<style lang="scss" scoped>
.side-page{
    overflow-y: scroll;
    position: fixed;
    z-index: 10;
    top: 0px;
    right: 0px;
    width: 70vw;
    max-width: 1600px;
    height: 100vh;
    background-color: white;
    transform: translateX(100%);
    transition: all .3s;
    @media screen and (max-width: 992px) {
        width: 100vw;
    }
    // padding: 30px 90px;
    &.active{
        transform: translateX(0px);
    }
    #side-page-controls-container{
        position: absolute;
        top: 0px;
        left: 0px;
        width: 40px;
        height: 100%;
    }
    .side-page-controls{
        position: sticky;
        top: 16px;
        margin-bottom: 16px;
        margin-top: 16px;
        padding-left: 32px;
        z-index: 100;
    }
    .side-page-close-btn{
        cursor: pointer;
    }
}
</style>